import { distance } from '@/js/hooks/math'
import Events from '@/js/core/EventDispatcher'
import MatchMedia from '@/js/core/MatchMedia'
import gsap from 'gsap'
import $ from 'jquery'

export default class Loader extends MatchMedia {
  static ACTIVE = 'loader--active'

  static root = '.loader'

  state = {
    ...this.state,
    boxes: [],
  }

  selectors = {
    wrapper: '.loader__wrapper',
    logo: '.loader__logo img',
  }

  actions = {
    breakpointSMMatches: 'resize',
    breakpointMDMatches: 'resize',
    breakpointLGMatches: 'resize',
    breakpointXLMatches: 'resize',
  }

  getBoxColums () {
    const {
      breakpointSMMatches,
      breakpointMDMatches,
      breakpointLGMatches,
    } = this.state

    return breakpointSMMatches
      ? 3 : breakpointMDMatches
      ? 4 : breakpointLGMatches
      ? 6 : 8
  }

  enabled () {
    const { breakpointSMMatches } = this.state
    return breakpointSMMatches !== undefined
  }

  resize () {
    if (!this.enabled) return
    
    const boxes = []
    const boxGridCols = this.getBoxColums()
    const boxRatio = window.innerWidth / window.innerHeight
    const boxSizeX = 100 / boxGridCols
    const boxSizeY = boxSizeX * boxRatio
    const boxGridRows = 100 / boxSizeY
    const boxSizeCeilX = Math.ceil(boxSizeX)
    const boxSizeCeilY = Math.ceil(boxSizeY)
    const boxGridCeilCols = Math.ceil(boxGridCols)
    const boxGridCeilRows = Math.ceil(boxGridRows)
    const boxGrid = boxGridCeilCols * boxGridCeilRows
    const boxOffsetX = boxSizeX * (boxGridCeilCols - 1) + boxSizeCeilX - 100
    const boxOffsetY = boxSizeY * (boxGridCeilRows - 1) + boxSizeCeilY - 100

    this.$.wrapper &&
    this.$.wrapper.empty().css({
      left: `-${boxOffsetX / 2}%`,
      top: `-${boxOffsetY / 2}%`,
    })

    for (let i = 0; i < boxGrid; ++i) {
      const x = i % boxGridCols
      const y = Math.floor(i / boxGridCols)
      const d = distance({ x:  0, y: 0 }, { x, y })

      const $box = $('<div />')

      gsap.set($box, {
        height: `${boxSizeCeilY}%`,
        width: `${boxSizeCeilX}%`,
        left: `${x * boxSizeX}%`,
        top: `${y * boxSizeY}%`,
      })

      this.$.wrapper && 
      this.$.wrapper.append($box)
      
      boxes.push({ d, $box })
    }

    this.state.boxes = boxes.sort((a, b) => a.d > b.d ? 1 : b.d > a.d ? -1 : 0).map(({ $box }) => $box)
  }

  enter () {
    return new Promise(resolve => {
      const { logo } = this.$els
      const boxes = this.state.boxes
      gsap.timeline({ onStart: () => {
            this.$.body.addClass(Loader.ACTIVE)
            this.$.el.show()
          }, onComplete: resolve })
          .fromTo(boxes, { autoAlpha: 0, scale: 0 }, { autoAlpha: 1, scale: 1, stagger: { amount: .4 }, duration: .6, ease: 'power2.out' }, '<')
          .fromTo(!$.device.mobile ? logo : {}, { yPercent: 100 }, { yPercent: 0, duration: 1, ease: 'expo.inOut' }, '<')
    })
  }

  leave () {
    const { logo } = this.$els
    const boxes = this.state.boxes
    gsap.timeline({ onComplete: () => {
          this.$.body.removeClass(Loader.ACTIVE)
          this.$.el.hide()
        } })
        .to(logo, { yPercent: 100, duration: 1, ease: 'expo.inOut' }, '<')
        .to(boxes, { autoAlpha: 0, scale: .5, stagger: { amount: .4 }, duration: .6, ease: 'power2.inOut' }, '<+.3')
  }
  
  mounted () {
    super.mounted()
    
    //this.resize()

    Events.on('dom:ready', () => {
      this.leave()
    })
    
    Events.on('router:push', ({ href }) => {
      this.enter().then(() => {
        window.location.href = href
      })
    })

    this.$.body.addClass(Loader.ACTIVE)
  }
}